import {getToken} from "@/utils/auth";
import {AnalysisTitle} from "@/api/index";
// import {formatSourceDataToSever} from "@/views/BCSProduct/style-xml-manager";

const state = {
    AnalysisTitle:{},

};

const mutations = {
    AnalysisTitle: (state, list) => {
        state.AnalysisTitle = list;
    },
    
}

const actions = {


    async AnalysisTitle({commit}) {  
        const {data} = await AnalysisTitle({userId: getToken()});
        console.log('AnalysisTitle',data);
        commit('AnalysisTitle', data);
    },
   

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
